import { Injectable } from '@angular/core';
import { EMPTY, Subscription, timer } from 'rxjs';
import { LoggerService } from '../logger/logger.service';
import { RestApiService } from '../rest-api/rest-api.service';
import { ToastNotificationService } from '../toast-notification/toast-notification.service';
import { catchError, filter, switchMap } from 'rxjs/operators';
import { ToastNotificationComponent } from 'src/app/shared/toast-notification/toast-notification.component';
import { ConfigService } from '../json-config.service';
import { EnvironmentKeys } from 'src/environments/environment-keys';
import { UserService } from '../user/user.service';

@Injectable({
  providedIn: 'root'
})
export class UserNotificationService {
  private _unreadNotificationsCount = 0;
  public bellSubscription?: Subscription;

  public get unreadNotificationsCount(): number {
    return this._unreadNotificationsCount;
  }

  private set unreadNotificationsCount(value: number) {
    this._unreadNotificationsCount = value;
  }

  public constructor(
    private restApiService: RestApiService,
    private toastService: ToastNotificationService,
    private loggerService: LoggerService,
    private configService: ConfigService,
    private userService: UserService,
  ) {
    this.bellSubscription = timer(0, this.configService.getConfig(EnvironmentKeys.headerNotificationsBellUpdateInMiliseconds))
      .pipe(
        filter(() => !!this.userService.loggedUser?.clientAccountId),
        switchMap(
          () => this.restApiService.getNewNotificationsCount()
            .pipe(
              catchError(err => {
                this.handleError(err)
                return EMPTY
              }))
        )
      ).subscribe({
        next: data => {
          this._unreadNotificationsCount = data.totalSum;
        },
      });
  }

  public updateNotificationsCount(): void {
    this.restApiService.getNewNotificationsCount().subscribe({
      error: this.handleError.bind(this),
      next: data => this._unreadNotificationsCount = data.totalSum,
    });
  }

  private handleError(err: unknown): void {
    this.unreadNotificationsCount = NaN;
    this.loggerService.error(err);
    this.toastService.addNotification({
      title: 'toastNotifications.headers.error',
      message: 'toastNotifications.messages.notificationsUpdateError',
      type: 'warning',
      component: ToastNotificationComponent
    });
  }
}
